var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomerAlign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1552",
    "data-name": "Rectangle 1552",
    width: 19,
    height: 19,
    transform: "translate(0.279 0.278)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Customer_Alignment",
    "data-name": "Customer Alignment",
    transform: "translate(-590 -301.662)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_444",
    "data-name": "Ellipse 444",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(590 301.662)",
    fill: "#ee3d4a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_31617",
    "data-name": "Group 31617",
    transform: "translate(595.721 307.383)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31616",
    "data-name": "Group 31616",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11975",
    "data-name": "Path 11975",
    d: "M.113,9.431a.532.532,0,0,0,.418.862H5.248l-.845.845a.529.529,0,1,0,.748.748L6.9,10.141a.53.53,0,0,0,0-.749L5.15,7.645a.537.537,0,0,0-.379-.162.529.529,0,0,0-.369.912l.841.842H.534a.533.533,0,0,0-.42.194ZM9.344.2a.544.544,0,0,0-.11.335V5.244L8.393,4.4a.529.529,0,0,0-.912.375.526.526,0,0,0,.162.373L9.391,6.9a.528.528,0,0,0,.748,0l1.747-1.747a.529.529,0,0,0,.006-.754.529.529,0,0,0-.754.006l-.845.845V.531a.541.541,0,0,0-.355-.5A.544.544,0,0,0,9.344.2ZM7.6,14.421a.53.53,0,0,0,.788.709l.845-.845,0,4.713a.53.53,0,1,0,1.058,0V14.284l.845.845a.529.529,0,0,0,.376.161.538.538,0,0,0,.378-.155.532.532,0,0,0,.155-.379.525.525,0,0,0-.161-.375L10.14,12.635a.53.53,0,0,0-.749,0L7.644,14.382C7.631,14.394,7.618,14.407,7.6,14.421Zm4.99-4.99a.529.529,0,0,0-.117.363.535.535,0,0,0,.156.348l1.747,1.745a.525.525,0,0,0,.375.161.532.532,0,0,0,.379-.155.538.538,0,0,0,.155-.378.529.529,0,0,0-.161-.376l-.845-.845h4.709a.53.53,0,1,0,0-1.058H14.287l.841-.841a.529.529,0,0,0,.006-.754.53.53,0,0,0-.754,0L12.634,9.392A.48.48,0,0,0,12.595,9.431Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerAlign);
export default __webpack_public_path__ + "static/media/customer-align.6a433b86ac53765a384f93219326ac8b.svg";
export { ForwardRef as ReactComponent };